import type { AccessTokenData } from '@empathyco/playboard-core-domain'
import type { AuthState, GetterClass } from '../../../models'
import type { AuthTokenService } from '../../../services'

import { CONTAINER } from '../../../config'

import { TYPES } from '../../../config/inversify.types'

export class TokenInfoGetter implements GetterClass {
  static execute(this: void, state: AuthState): AccessTokenData | undefined {
    const authTokenService: AuthTokenService = CONTAINER.get<AuthTokenService>(
      TYPES.AuthTokenService,
    )
    return state.token ? authTokenService.getInfo(state.token) : undefined
  }
}
